export class Box {
    id: number;
    name: string;
    pixBalance: any;
    caixaBalance: any;
    cartaoBalance: any;
    createdAt: any;	
    active: any;

    constructor(id: number, name: string,pixBalance: any,caixaBalance: any,cartaoBalance: any,createdAt: any, active: any) {
        this.id = id;
        this.name = name;
        this.pixBalance = pixBalance;
        this.caixaBalance = caixaBalance;
        this.cartaoBalance = cartaoBalance;
        this.createdAt = createdAt;
        this.active = active;
    }
}